<template>
  <div class="mb-3 cursor-pointer">
    <label class="block text-white/90 text-base leading-[1.18rem] mb-3 pl-[10px]">{{ $t(label) }}</label>
    <div
        class="'w-full h-[44px] hover:bg-[#2A323B] bg-[#22282F] rounded-[10px] px-3 border-2 border-transparent focus:border-[#6CBFFF] text-white flex items-center gap-2"
    >
      <img :src="'/data/flags/' + getUserLanguage.code + '.png'" alt="" class="w-4 h-4 rounded-full overflow-hidden">
      <span>{{ getUserLanguage.name }}</span>
    </div>
  </div>

</template>

<script lang="ts" setup>
import {computed, defineProps, withDefaults} from "vue";
import { useLanguages } from '@/composables/useLanguages'
import { Constants } from '@/cfg/constants'

const { languages } = useLanguages()

const props = withDefaults(defineProps<{
  initial?: string,
  label?: string,

}>(), {
  initial: Constants.DEFAULT_LANGUAGE,
  label: "profile_language",
})

const selectedLangCode = computed(() => props.initial || Constants.DEFAULT_LANGUAGE)

const getUserLanguage = computed(() => {
  let selectedLang = false;

  languages.value.forEach(lang => {
    if (lang.code == selectedLangCode.value && lang.dialects.length <= 1) {
      selectedLang = lang;
      return;
    } else {
      lang.dialects.forEach(dialect => {
        if (dialect.code == selectedLangCode.value) {
          selectedLang = dialect;
          return;
        }
      });
    }
  });
  return selectedLang;
})

</script>